import { Flex, Icon, MenuItem, Text } from "@chakra-ui/react";

const SortItem = ({ item, handler }) => {
  return (
    <MenuItem>
      <Flex align={"center"} columnGap={"4px"} onClick={() => handler(item)}>
        <Icon as={item?.icon} w={"16px"} h={"16px"} />
        <Text>{item?.title}</Text>
      </Flex>
    </MenuItem>
  );
};

export default SortItem;
